import React from 'react';
import cn from 'classnames';
import { Box, Flex } from '@semcore/ui/flex-box';

import ErrorBoundary from '@authFlow/components/ErrorBoundary/ErrorBoundary';
import { getPageNameItemLocation } from '@authFlow/utils/analytics/pageNameItemLocations';
import { onLogoClick } from '@authFlow/utils/redirect';
import { AuroraAnimation } from '@authFlow/components/AuroraAnimation';

import { useLayoutFlags } from './useLayoutFlags';
import logo from './images/semrush-logo-small.svg';
import styles from './Layout.scss';

type Props = {
  children: React.ReactNode;
  pathname?: string;
};

const Header = () => {
  return (
    <Flex className={styles.header}>
      <Box
        tag={'a'}
        href="/"
        onClick={onLogoClick}
        id={'header-logo'}
        className={styles.logo}
        data-ga4-event-onclick
        data-ga4-label={'logo'}
        data-ga4-path={'link'}
      >
        <img src={logo} alt="Semrush" width={136} height={18} />
      </Box>
    </Flex>
  );
};

const Layout = ({ pathname, children }: Props) => {
  const pageName = getPageNameItemLocation(pathname);
  const {
    isWowAISeoFlow,
    shouldShowAurora,
    showWowAISeoFlowFirstAnimation,
    isEntSolSignupFlow,
  } = useLayoutFlags(pathname);

  return (
    <div
      id={'layout'}
      className={cn(styles.layout, {
        [styles.layoutWowAISeo]: isWowAISeoFlow || isEntSolSignupFlow,
      })}
      data-ai-seo-animation={showWowAISeoFlowFirstAnimation}
      data-ga4-wt-page-path={pageName}
    >
      <Header />

      <ErrorBoundary>{children}</ErrorBoundary>

      {shouldShowAurora && <AuroraAnimation />}
    </div>
  );
};

export default Layout;
